import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const IconPendingPaymentFill = ({color, ...props}: IconProps) => {
    return (
        <svg width="45" height="31" viewBox="0 0 45 31" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect
                x="1.53572"
                y="1.05525"
                width="37.0397"
                height="24.0026"
                rx="5.17859"
                fill="white"
                stroke={color || "#000"}
                strokeWidth="2.07143"
            />
            <g clipPath="url(#clip0_858_69890)">
                <path
                    d="M15.4762 15.1821H21.576C21.7231 15.1821 21.8642 15.1188 21.9681 15.0062C22.0721 14.8935 22.1306 14.7407 22.1306 14.5814C22.1306 14.422 22.0721 14.2692 21.9681 14.1566C21.8642 14.0439 21.7231 13.9806 21.576 13.9806H17.1398C16.4045 13.9806 15.6992 13.6642 15.1793 13.1009C14.6593 12.5376 14.3672 11.7736 14.3672 10.9769C14.3672 10.1803 14.6593 9.41632 15.1793 8.85302C15.6992 8.28972 16.4045 7.97326 17.1398 7.97326H18.2489V5.57031H20.467V7.97326H23.2396V10.3762H17.1398C16.9928 10.3762 16.8517 10.4395 16.7477 10.5522C16.6437 10.6648 16.5853 10.8176 16.5853 10.9769C16.5853 11.1363 16.6437 11.2891 16.7477 11.4017C16.8517 11.5144 16.9928 11.5777 17.1398 11.5777H21.576C22.3114 11.5777 23.0166 11.8941 23.5366 12.4574C24.0566 13.0207 24.3487 13.7847 24.3487 14.5814C24.3487 15.378 24.0566 16.142 23.5366 16.7053C23.0166 17.2686 22.3114 17.5851 21.576 17.5851H20.467V19.988H18.2489V17.5851H15.4762V15.1821Z"
                    fill={color || "#000"}
                />
            </g>
            <rect
                x="6.88672"
                y="6.40625"
                width="36.1111"
                height="23.0741"
                rx="4.7143"
                fill="#6941C6"
                stroke="#6941C6"
                strokeWidth="3"
            />
            <g clipPath="url(#clip1_858_69890)">
                <path
                    d="M20.3669 20.0727H26.4667C26.6137 20.0727 26.7548 20.0094 26.8588 19.8968C26.9628 19.7841 27.0212 19.6313 27.0212 19.472C27.0212 19.3127 26.9628 19.1599 26.8588 19.0472C26.7548 18.9346 26.6137 18.8713 26.4667 18.8713H22.0304C21.2951 18.8713 20.5899 18.5548 20.0699 17.9915C19.5499 17.4282 19.2578 16.6642 19.2578 15.8676C19.2578 15.0709 19.5499 14.3069 20.0699 13.7436C20.5899 13.1803 21.2951 12.8639 22.0304 12.8639H23.1395V10.4609H25.3576V12.8639H28.1302V15.2668H22.0304C21.8834 15.2668 21.7423 15.3301 21.6383 15.4428C21.5343 15.5554 21.4759 15.7082 21.4759 15.8676C21.4759 16.0269 21.5343 16.1797 21.6383 16.2924C21.7423 16.405 21.8834 16.4683 22.0304 16.4683H26.4667C27.202 16.4683 27.9072 16.7848 28.4272 17.3481C28.9472 17.9114 29.2393 18.6754 29.2393 19.472C29.2393 20.2686 28.9472 21.0326 28.4272 21.5959C27.9072 22.1592 27.202 22.4757 26.4667 22.4757H25.3576V24.8786H23.1395V22.4757H20.3669V20.0727Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_858_69890">
                    <rect x="11.9102" y="4.90625" width="14.7419" height="15.9704" rx="4.73523" fill="white" />
                </clipPath>
                <clipPath id="clip1_858_69890">
                    <rect x="16.7969" y="9.79297" width="14.7419" height="15.9704" rx="4.73523" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default IconPendingPaymentFill
